import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReferral = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "800px",
	height: "800px",
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7 21V18M14 21V17.6599C14 16.6974 14.6855 15.8715 15.6314 15.6941L21.1085 14.6672C21.6254 14.5702 22 14.1189 22 13.5929C22 12.9893 21.5107 12.5 20.9071 12.5H9.5C6.18629 12.5 3.5 15.1863 3.5 18.5V21M21 8L19 6M21 8L19 10.2592M21 8H16.5M14 6.5C14 8.70914 12.2091 10.5 10 10.5C7.79086 10.5 6 8.70914 6 6.5C6 4.29086 7.79086 2.5 10 2.5C12.2091 2.5 14 4.29086 14 6.5Z",
		stroke: "#000000",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.4
	})
});
export { SvgReferral as ReactComponent };
